// how long should a claimed lock last for
export const LOCK_VALID_FOR = 30
// once a lock is obtained, how often should you refresh the locks timeout
export const LOCK_REFRESH_TIME = 20
// how often should you check for new lock data
export const LOCK_CHECK_TIME = 2.5
